<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 2.75C6 2.33579 6.33579 2 6.75 2H13.25C13.6642 2 14 2.33579 14 2.75C14 3.16421 13.6642 3.5 13.25 3.5H10.7445L6.8874 12.5H9.25C9.66421 12.5 10 12.8358 10 13.25C10 13.6642 9.66421 14 9.25 14H2.75C2.33579 14 2 13.6642 2 13.25C2 12.8358 2.33579 12.5 2.75 12.5H5.25545L9.1126 3.5H6.75C6.33579 3.5 6 3.16421 6 2.75Z"
    fill="currentColor"
  />
</svg>
